import React from 'react';
import Spacer from '../../components/common/spacer/Spacer';

require('./style.scss');

const Footer = () =>
  <footer id="site-footer">
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-8">
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://mpaani.com"
          >
            <img
              role="presentation"
              src="/static/images/mpaani-logo-white.png"
            />
          </a>
        </div>

        <div className="col-md-6">
          <div className="nav">
            <div className="nav-title">Aadhik Jankari</div>

            <div className="nav-pill">
              <a
                rel="noreferrer noopener"
                href="http://mpaani.com/terms"
                target="_blank"
              >
                Terms and Conditions
              </a>
            </div>
            <div className="nav-pill">
              <a
                rel="noreferrer noopener"
                href="http://mpaani.com/grow-your-business"
                target="_blank"
              >
                Partner Store Banoge?
              </a>
            </div>
          </div>
        </div>

        <div className="col-md-5">
          <div className="nav">
            <div className="nav-title">Connect</div>

            <div className="nav-pill">
              <a
                rel="noreferrer noopener"
                target="_blank"
                href="https://www.facebook.com/mpaani/"
              >
                <img alt="Facebook" src="/static/images/facebook.png" />
              </a>&nbsp;
              <a
                rel="noreferrer noopener"
                target="_blank"
                href="https://twitter.com/mpaani"
              >
                <img alt="Twitter" src="/static/images/twitter.png" />
              </a>
              <a
                rel="noreferrer noopener"
                target="_blank"
                href="https://www.instagram.com/m.paani/"
              >
                <img alt="Mail" src="/static/images/instagram.png" />
              </a>
            </div>
          </div>
        </div>

        <div className="col-md-5">
          <div className="nav">
            <div className="nav-title">Download App</div>

            <div className="nav-pill" id="app-link">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://play.google.com/store/apps/details?id=chotelal.mpaani.com.android.chotelal"
              >
                <img
                  role="presentation"
                  src="/static/images/app_download_footer.png"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <Spacer size={2} />

      <div className="col-md-24 text-center" id="copyright">
        <Spacer size={2} />
        <small>Copyright &copy; 2019 Mpaani Solutions Private Limited</small>
        <Spacer size={2} />
      </div>
    </div>
  </footer>;

module.exports = Footer;



// WEBPACK FOOTER //
// ./app/layouts/footer/Footer.jsx